import {
  USER_AUTH_VALIDATING,
  USER_AUTH_DONE_VALIDATING,
  USER_RECEIVE_DETAILS_AND_TOKEN,
  USER_RECEIVE_NEW_EMAIL,
  USER_SIGN_OUT,
  USER_ID,
  USER_ACCEPT_TOC,
  USER_HYDRATE,
} from "../actionTypes";

const initialState =  {
  auth_token: null,
  auth_validating: false,
  id: null,
  first_name: null,
  last_name: null,
  email: null,
  new_email_temp: null,
  profile_photo: null,
  company_slug: null,
  loan_plans: [],
  active_loan_offers: [],
  has_loan_offers_for_acceptance: false,
  repayments: [],
  trustpasses_incomplete: false,
  active_business_trustpass: {},
  active_personal_trustpass: {},
  kyc_verified: false,
  kyc_verified_at_least_once: false,
  has_current_terms_accepted: null,
  loan_application_id: null,
  trade_document: {},
  has_trade_documents: false,
  passwordResetSuccess: false,
  role: '',
  is_sales_qualified: false,
  is_not_sales_qualified: false,
  is_from_csv: false,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case USER_AUTH_VALIDATING:
      return {
        ...state,
        auth_validating: true,
      };
    case USER_AUTH_DONE_VALIDATING:
      return {
        ...state,
        auth_validating: false,
      };
    case USER_ACCEPT_TOC:
      return {
        ...state,
        has_current_terms_accepted: true,
      };
    case USER_HYDRATE:
      return { ...state, ...action.payload }
    case USER_SIGN_OUT:
      return {
        ...state,
        ...initialState,
      };
    case USER_RECEIVE_NEW_EMAIL:
      return {
        ...state,
        email: action.payload.email,
        new_email_temp: action.payload.new_email_temp,
      }
    case USER_RECEIVE_DETAILS_AND_TOKEN:
      return {
        ...state,
        auth_token: action.payload.auth_token,
        id: action.payload.id,
        first_name: action.payload.first_name,
        last_name: action.payload.last_name,
        email: action.payload.email,
        new_email_temp: action.payload.new_email_temp,
        profile_photo: action.payload.profile_photo,
        phones: action.payload.phones,
        company_slug: action.payload.company_slug,
        trustpasses_incomplete: action.payload.trustpasses_incomplete,
        active_business_trustpass: action.payload.active_business_trustpass,
        active_personal_trustpass: action.payload.active_personal_trustpass,
        kyc_verified: action.payload.kyc_verified,
        kyc_verified_at_least_once: action.payload.kyc_verified_at_least_once,
        has_current_terms_accepted: action.payload.has_current_terms_accepted,
        loan_application_id: action.payload.loan_application_id,
        bank_accounts: action.payload.bank_accounts,
        user_active: action.payload.user_active,
        accepted_loan_offers_count: action.payload.accepted_loan_offers_count,
        has_loan_offers_for_acceptance: action.payload.has_loan_offers_for_acceptance,
        has_trade_documents: action.payload.has_trade_documents,
        company_id: action.payload.company_id,
        onboarding: action.payload.onboarding,
        onboarding_finished: action.payload.onboarding_finished,
        role: action.payload.role,
        is_sales_qualified: action.payload.is_sales_qualified,
        is_not_sales_qualified: action.payload.is_not_sales_qualified,
        is_from_csv: action.payload.is_from_csv,
      };
    case USER_ID:
      return {
        ...state,
        id: action.payload,
      };
    case "RECEIVE_PERSONAL_TRUSTPASS":
    case 'PERSONAL_TRUSTPASS_STATUS_UPDATE':
      return {
        ...state,
        onboarding: { ...state.onboarding, ptp_submitted: true },
      };
    case 'BUSINESS_TRUSTPASS_STATUS_UPDATE':
      return {
        ...state,
        onboarding: { ...state.onboarding, btp_submitted: true },
      };
    case 'FINISH_ONBOARDING':
      return { ...state, onboarding_finished: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/reducers/user.js